let loaded = false;
document.addEventListener("DOMContentLoaded", function () {
	if (!loaded) {
		const formProduct = document.querySelector(".shopify-product-form");
		// addMutationObserver(formProduct, triggerNotify);
		loaded = true;
		showMore();
	}
});

isNotifyReady = false;

function addMutationObserver(selector, customCallback) {
	// console.log("Observer | addMutationObserver added");
	let targetNode = selector;
	if (targetNode) {
		// console.log("Observer | target on node");
		let config = { attributes: true, childList: true, subtree: true };
		const callback = function (mutationsList, observer) {
			// console.log("Observer | callback called");
			// isNotifyReady = false;
			// Use traditional 'for loops' for IE 11
			for (const mutation of mutationsList) {
				if (mutation.type === "childList") {
					if (isNotifyReady == false) {
						customCallback();
					}
				} else if (mutation.type === "attributes") {
				}
			}
		};

		let observer = null;
		observer = new MutationObserver(callback);
		observer.observe(targetNode, config);
	}
}

function triggerNotify() {
	console.log("***TRIGGER***");
	console.log(productTranslations.notifyMeText);

	const isNotifyVisible =
		document.querySelector(".restock-alerts-notify-button") &&
		document.querySelector(".restock-alerts-notify-button").style.display != "none";

	console.log(isNotifyVisible);

	if (isNotifyVisible) {
		const restockBtn = document.querySelector(".restock-alerts-notify-button");
		restockBtn.removeAttribute("style");
		restockBtn.innerHTML = productTranslations.notifyMeText;
		resetNotify();
	}
	if (isNotifyVisible) {
		if (document.querySelector(".bestpush-bis-notify-status")) {
			document.querySelector(".bestpush-bis-notify-status").innerHTML = productTranslations.notifyMeStatusText;
			resetNotify();
		}
	}
}

const resetNotify = () => {
	isNotifyReady = true;
	setInterval(() => {
		isNotifyReady = false;
	}, 100);
};

// Fix Read-More

function showMore() {
	console.log("int prod");
	const btnShow = document.getElementById("Product__show-more");
	let shortDesc = document.getElementById("desc-short");
	let longDesc = document.getElementById("desc-long");
	try {
		btnShow.addEventListener("click", () => {
			if (btnShow.getAttribute("data-desc-open") == "false") {
				shortDesc.style.display = "none";
				longDesc.style.display = "block";
				btnShow.innerHTML = "Read Less";
				btnShow.setAttribute("data-desc-open", "true");
			} else {
				shortDesc.style.display = "block";
				longDesc.style.display = "none";
				btnShow.innerHTML = "Read more";
				btnShow.setAttribute("data-desc-open", "false");
			}
		});
	} catch (err) {
		console.log(err);
	}
}
